export default __webpack_public_path__ + "static/media/2_gimH.8710d681.svg";